import { Container, Typography } from '@mui/material';
import { TabsController } from './components/TabsController';

export const TimeTrackingTool = () => {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 2 }}>
        Time Tracker
      </Typography>
      <TabsController />
    </Container>
  );
};
